import React from 'react';
import {actionApiCall, rffFormSubmit} from '@mc/react-app-v4';
import {Button, Callout, Dialog, DialogBody, DialogFooter, Modal, ModalComponentProps, Text, Title, VF} from '@mc/ui-v4';
import {ExportFormat, getExportFormatItems} from '../../enums/ExportFormats';
import {Form, FormRenderProps} from 'react-final-form';
import {FeaturePointerVO, ExportImportApi, PublicExportApi} from '../../api';
import {set} from 'lodash-es';
import {SERVER_CONTEXT_PATH} from '../../const';
import {useAppConfig} from '@mc/react-app-base';
import {useMapioContext} from '../../mapioContext';
import {ApiCallWaitingModal} from './ApiCallWaitingModal';
import {downloadFile} from '../../helpers/FileDownload';

export const ExportObjektuModal: React.FC<ModalComponentProps> = ({onClose}) => {
    //@ts-ignore
    const {serverPublic} = useAppConfig();
    const {selectedDetailFeature} = useMapioContext().value;
    const formats = getExportFormatItems(serverPublic);

    return (
        <Form
            validate={async data => {
                const errors = {};
                if (!data.format) {
                    set(errors, 'format', 'Vyberte formát exportu');
                }
                if (!selectedDetailFeature || selectedDetailFeature?.length < 1) {
                    set(errors, 'checked', 'Vyberte alespoň jeden objekt');
                }
                return errors;
            }}
            onSubmit={async data => {
                return await rffFormSubmit(async (): Promise<void> => {
                    const featurePointers = selectedDetailFeature.map(({groupId, ...item}) => item) as FeaturePointerVO[];
                    let result: string;
                    if (serverPublic) {
                        if (data.format !== ExportFormat.xlsx) {
                            throw new Error(`Nepodporovaný formát exportu: ${data.format}`);
                        }
                        result = await Modal.showWaiting(
                            actionApiCall(async () => (await PublicExportApi.exportToExcel({featurePointers})).data),
                            props => <ApiCallWaitingModal {...props} title={'Probíhá export'} />,
                        );
                    } else {
                        result =
                            SERVER_CONTEXT_PATH +
                            (await Modal.showWaiting(
                                actionApiCall(async () => (await ExportImportApi.exportFeaturePointersFile(data.format, featurePointers)).data),
                                props => <ApiCallWaitingModal {...props} title={'Probíhá export'} />,
                            ));
                    }
                    downloadFile(result);
                    onClose();
                });
            }}
            initialValues={{
                format: formats.length === 1 ? formats[0].id : undefined,
            }}
        >
            {({submitting, handleSubmit, errors, submitFailed}: FormRenderProps) => {
                return (
                    <Dialog size={'sm'} onClose={onClose} title={'Export objektů'} autoFocus={false}>
                        <DialogBody>
                            <Title type={'block'}>Objekty k exportu</Title>
                            <Text>
                                Počet vybraných objektů k exportu: <strong>{!selectedDetailFeature ? 0 : selectedDetailFeature.length}</strong>
                            </Text>
                            {errors?.checked && submitFailed && <Callout intent={'danger'}>{errors.checked}</Callout>}
                            <Title className={'mt-1'} type={'block'}>
                                Nastavení
                            </Title>
                            <VF.SelectBox
                                name={'format'}
                                required
                                label={'Formát'}
                                items={formats}
                                readOnly={formats.length === 1}
                                disabled={submitting}
                                useIdAsValue
                            />
                        </DialogBody>
                        <DialogFooter>
                            <Button style={'default'} onClick={() => onClose()} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} onClick={handleSubmit} disabled={submitting}>
                                Exportovat
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
